<template>
    <Select
        ref="selectElm"
        clearable
        filterable
        remote
        transfer
        :multiple="multiple"
        :remote-method="q=>{load_throttle(q)}"
        @on-query-change="_queryChange"
        @on-change="_change"
        @on-open-change="_openChange"
        :loading="loading"
        v-model="selectedValue"
        :label-in-value="true"
        :label="label"
        :size="size"
        :placeholder="$t('Message.placeholderSelect')"
    >
        <Option v-for="item in list" :value="item.value" :key="item.value">{{ item.label }}</Option>
    </Select>
</template>
<script>
import api from "@/api/Api";
import extend from "extend";
import throttle from "lodash.throttle";

/*
    额外需求 NEED：
    NEED-1 输入完整名字后，自动选择
    NEED-2 手动清空输入后，需要显示可选列表
    NEED-3 外部可以获取label

*/
export default {
    props: ["size", "value", "api", "multiple", "label", "refreshList", "userId","selectType"],
    data() {
        return {
            loading: false,
            selectedValue: this.value,
            option: null, //NEED-3
            initialList: [], //初始列表
            list: [] //当前列表
        };
    },
    watch: {
        value() {
            this.selectedValue = this.value;
        },
        label() {
            this.$refs.selectElm.setQuery(this.label);
        },
        selectedValue() {
            this.$emit("input", this.selectedValue);
        },
        refreshList() {
            this.load();
        },
        depId() {
            this._queryChange();
            
            if(this.api == 'liveMaterialCategory') {
                this.load();
            }
        }
    },
    computed: {
        depId(){
            return this.$store.state.department.currentId;
        }
    },
    methods: {
        data() {
            //NEED-3
            return this.option;
        },
        _openChange() {
            // this.load();
        },
        _queryChange(query) {
            //NEED-2: 手动清空input时，需要取消选定，否则blur时会自动恢复
            if (query == "") this.selectedValue = undefined;

            //NEED-1: query刚好匹配选项时立即选定，否则blur后会清空
            let found = this.list.filter(i => i.label == query)[0];
            if (found) {
                this.selectedValue = found.value;
            }
        },
        _change(option) {
            //NEED-3: 传递on-change事件，记录option
            this.option = option;
            this.list = this.initialList;
            this.$emit("on-change", option);
        },
        async load(query) {
            //无需再次获取初始列表
            if (query == "" && this.initialList.length) return;

            //选择item时会触发请求，此处避免。
            if (this.option && query == this.option.label) return;

            this.loading = true;
            try {
                switch (this.api) {
                    case "topic":
                        this.list = (await api.call("materialCms/topic", {
                            userId: parseInt(this.userId),
                            name: query,
                            page: 1,
                            size: 100
                        })).list.map(i => ({
                            value: i.topicId,
                            label: i.topicName
                        }));
                        break;
                    case "category":
                        this.list = (await api.call("materialCms/categories", {
                            name: query,
                            page: 1,
                            size: 100
                        })).list.map(i => ({
                            value: i.categoryId,
                            label: i.categoryName
                        }));
                        break;
                    case "liveMaterialCategory":
                        let param = {
                            selectType: 1,
                            // depId: this.depId,
                            topicName: query || "",
                            page: 1,
                            pageSize: 100,
                            userId: this.userId,
                        };
                        this.list = (await api.call("material/categoryList", param)).list.map(i => ({
                            value: i.topicId,
                            label: i.topicName
                        }))
                        break;
                    // case "template":
                    //     this.list = (await api.call("template/list", {
                    //         name: query,
                    //         page: 1,
                    //         size: 100
                    //     })).list.map(i => ({
                    //         value: i.id,
                    //         label: i.title
                    //     }));
                    //     break;
                }

                if (!query) this.initialList = extend(true, [], this.list);
                if (!this.list.length) this.list = this.initialList;
            } catch (e) {;}
            this.loading = false;
        }
    },
    mounted() {
        this.load_throttle = throttle(this.load, 1000);
        this.load();
    }
};
</script>
